import { ability } from 'configs/ability';

export const setHiddenColumns = (hiddenColumns: string[]) => {
  if (ability.cannot('update', 'User')) return [...hiddenColumns];
  else return [];
};
